<template>
  <span
    v-bind="$attrs"
    class="ui-featured-icon"
    :class="[`ui-featured-icon--${size}`, { border, rings, rounded }]"
    :style="{ backgroundColor: backgroundColor ? `var(--${backgroundColor})` : undefined, color: iconColor ? `var(--${iconColor})` : undefined }"
  >
    <span v-if="rings" aria-hidden="true" class="ui-featured-icon__rings" />
    <slot><Icon v-if="name" :name="name" /></slot>
  </span>
</template>
<script setup lang="ts">
  import type { ColorVariables } from '@shared/types'

  import { Icon, type IconName } from '../Icon'

  defineOptions({ inheritAttrs: false })
  withDefaults(
    defineProps<{
      backgroundColor?: ColorVariables
      border?: boolean
      iconColor?: ColorVariables
      name?: IconName
      rings?: boolean
      rounded?: boolean
      size?: 'lg' | 'md' | 'sm' | 'xl'
    }>(),
    { border: true, rings: false, rounded: false, size: 'md' },
  )
</script>
<style scoped>
  .ui-featured-icon {
    position: relative;
    display: inline-flex;
    flex: none;
    align-items: center;
    justify-content: center;
    color: var(--featured-icon-light-fg-brand);
    background: var(--color-background-bg-brand-secondary);
  }

  .ui-featured-icon i {
    color: inherit;
  }

  .ui-featured-icon.border {
    box-shadow: inset 0 0 0 1px var(--color-border-border-secondary);
  }

  .ui-featured-icon.rounded {
    border-radius: 50%;
  }

  .ui-featured-icon--sm {
    width: 32px;
    height: 32px;
    border-radius: var(--radius-md);
  }

  .ui-featured-icon--md {
    width: 40px;
    height: 40px;
    border-radius: var(--radius-lg);
  }

  .ui-featured-icon--lg {
    width: 48px;
    height: 48px;
    border-radius: var(--radius-xl);
  }

  .ui-featured-icon--xl {
    width: 56px;
    height: 56px;
    border-radius: 14px;
  }

  .ui-featured-icon__rings {
    position: absolute;
    inset: -50%;
    border: 1px solid currentcolor;
    border-radius: 50%;
    opacity: 0.14;
  }
</style>
